import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";

import {
  localGetMenu,
  localGetRefreshToken,
  localRemoveMenu,
  localRemoveRefreshToken,
  localRemoveToken,
  localSaveRefreshToken,
  localSaveToken,
} from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyWarning } from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL } from "../../../services/api/config";
import { DatePicker } from "antd";
import moment from "moment";
import { AiOutlineDollar } from "react-icons/ai";
const ChartTopLeft = () => {
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState([]);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [dates, setDates] = useState([]);
  const [hackValue, setHackValue] = useState();
  const [value, setValue] = useState();
  const getData = async () => {
    setLoading(true);
    setDataSource([]);
    try {
      let { data } = await api.get(`${API_URL}api/v1/reports/reward-report`, {
        reward_date_from: value
          ? value[0].format("YYYY-MM-DD")
          : moment().add(-1, "M").format("YYYY-MM-DD"),
        reward_date_to: value
          ? value[1].format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
      });
      //  console.log("123", data.rewards);
      // let fakeDate = [...data.rewards].map((x) => {
      //   return [
      //     moment(x.reward_date, "YYYY-MM-DD").add(7, "h"),
      //     Number(x.reward).toFixed(0),
      //   ];
      // });
      // console.log("123", fakeDate);
      let fakeTotal = 0;

      for (let i = 0; i < data.rewards.length; i++) {
        fakeTotal = fakeTotal + Number(data.rewards[i].reward);
      }
      setLoading(false);

      // let fakeNew = [1, 2, 3, 4].map((x) => {
      //   return [
      //     moment().add(x, "d").format("YYYY-MM-DD"),
      //     Number(0).toFixed(0),
      //   ];
      // });
      // fakeDate.push(fakeNew[0]);
      // fakeDate.push(fakeNew[1]);
      // fakeDate.push(fakeNew[2]);
      // fakeDate.push(fakeNew[3]);
      setTotal(fakeTotal.toFixed(2));
      setDataSource(data?.rewards);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };
  const disabledDate = (current) => {
    if (!dates || dates.length === 0) {
      return current && current > moment().endOf("day");
    }
    const tooLate =
      dates[0] &&
      (current.diff(dates[0], "days") > 365 || current > moment().endOf("day"));
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 365;
    return tooEarly || tooLate;
  };

  const onOpenChange = (open) => {
    if (open) {
      setHackValue([]);
      setDates([]);
    } else {
      setHackValue(undefined);
    }
  };
  useEffect(() => {
    getData();
  }, [value]);

  const CustomTooltip = ({ active, payload, label }) => {
    const isVisible = active && payload && payload.length;
    return (
      <div
        className="custom-tooltip"
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        {isVisible && (
          <div
            style={{
              background: "#fff",
              padding: "12px",
              borderRadius: "4px",
            }}
          >
            <p className="label" style={{ fontSize: "14px" }}>
              {`${label}`}
            </p>
            <p className="desc" style={{ fontSize: "14px" }}>
              Lợi nhuận: {`${payload[0].value}`}$
            </p>
          </div>
        )}
      </div>
    );
  };
  return (
    <div style={{ background: "#fff", padding: "8px", borderRadius: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            marginLeft: "16px",
          }}
        >
          <AiOutlineDollar size={24} />
          &nbsp;Lợi nhuận
        </p>
        <DatePicker.RangePicker
          style={{ width: "240px" }}
          value={hackValue || value}
          disabledDate={disabledDate}
          placeholder={[
            moment().add(-1, "M").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ]}
          onCalendarChange={(val) => setDates(val)}
          onChange={(val) => setValue(val)}
          onOpenChange={onOpenChange}
          inputReadOnly
        />
      </div>{" "}
      <div style={{ width: "100%", height: 350 }}>
        <div style={{ width: "100%", textAlign: "center", fontSize: "18px",fontWeight:"bold" }}>
          Tổng lợi nhuận: {`${total}`}$
        </div>
        <ResponsiveContainer>
          <AreaChart
            width={500}
            height={400}
            data={dataSource}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="reward_date" />
            <YAxis />
            <Tooltip content={CustomTooltip} />
            <Area
              type="monotone"
              dataKey="reward_usd"
              stroke="#8884d8"
              fill="#8884d8"
              label="Lợi nhuận"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartTopLeft;
